export default __webpack_public_path__ + "static/media/login.0d1118d3.svg";